import { FC, HTMLProps } from "react";
import cn from "classnames";
import { useInPageContext } from "../in-page-context";

export type InPageDescriptionProps = HTMLProps<HTMLParagraphElement>;

const InPageDescription: FC = ({
  children,
  className,
  ...rest
}: InPageDescriptionProps) => {
  const { getBlocksWith } = useInPageContext();

  return (
    <p {...rest} className={cn(className, getBlocksWith("__description"))}>
      {children}
    </p>
  );
};

export default InPageDescription;
